<template>
  <div class="company-links">
    <h2>COMPANY</h2>
    <ul>
      <li>
        <a href="/store/subscriptions">Pricing</a>
      </li>
      <!-- <li>
        <a href="/gift">Gift Cards</a>
      </li> -->
      <li>
        <span @click="setShowingModal('customer support')">
          Customer Support
        </span>
      </li>
      <li>
        <a href="/instapro">Become a Coach</a>
      </li>
      <li>
        <span @click="setShowingModal('partner form')"> Become a Partner </span>
      </li>
      <li>
        <a href="/terms_and_conditions">Terms and Conditions</a>
      </li>
      <li>
        <a href="/privacy_policy">Privacy Policy</a>
      </li>
      <li>
        <a @click="resetCookieNotice">Cookie Notice</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations } from "vuex"
export default {
  methods: {
    ...mapMutations("Modals", ["setShowingModal"]),
    resetCookieNotice() {
      localStorage.removeItem("pg_cookie_notice_dismissed");
      window.location.reload();
    }
  },
}
</script>

<style lang="scss" scoped>
.company-links {
  @import "@/assets/style/_mixins.scss";
  text-align: left;
  min-width: 24.8rem;
  padding-left: 4rem;
  @include desktop-down {
    min-width: unset;
  }
  @include phone-down {
    padding: 0;
  }
  h2 {
    font-family: Proxima Nova;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.8rem;
    color: #fff;
    margin-bottom: 2.5rem;
  }
  ul {
    padding: 0;
    li {
      list-style: none;
      margin-bottom: 0.8rem;
      a,
      span {
        font-family: Proxima Nova;
        font-weight: 400;
        font-size: 1.5rem;
        line-height: 1.8rem;
        color: #e3e8ed;
        cursor: pointer;
        &:hover {
          filter: brightness(2);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/main_footer/CompanyLinks.vue